import url from 'url'
import React, { Component } from 'react'
import { createComponent } from '@ycos/fela'
import { bool, string, shape, func } from 'prop-types'
import { Button, ButtonOutline, Caption, Link, LabelLink } from '@ycos/primitives'

const CTA_MAX_WIDTH = '326px'

const getLinkType = (brand, href) => {
  const stringMatches = {
    nap: 'net-a-porter',
    mrp: 'mrporter',
    theoutnet: 'theoutnet'
  }

  const parsedUrl = url.parse(href)
  let useSameTab = true
  if (parsedUrl.host !== null && !parsedUrl.host.includes(stringMatches[brand]) && !href.startsWith('mailto')) {
    useSameTab = false
  }

  return useSameTab ? '_self' : '_blank'
}

class CallToAction extends Component {
  static layoutVariant = ['isc-cta-primary', 'isc-cta-secondary', 'isc-cta-large-text', 'isc-cta-small-text']

  render() {
    const { brand, disabled, onTargetClick, inverted } = this.props
    const { href, layoutVariant, subTitlePlain, dataCmMetadata, ...item } = this.props.item
    const ctaLink = disabled ? null : href
    const text = item.teaserTitle || item.target.teaserTitle

    const linkTargetType = getLinkType(brand, href)

    const ctaVariants = {
      'isc-cta-primary': (
        <Wrapper data-cm-metadata={dataCmMetadata}>
          <Link data-automation="isc-cta-primary" href={ctaLink} onClick={onTargetClick} target={linkTargetType}>
            <Button disabled={disabled} inverted={inverted}>{text}</Button>
          </Link>
          {subTitlePlain && <CtaCaption>{subTitlePlain}</CtaCaption>}
        </Wrapper>
      ),
      'isc-cta-secondary': (
        <Wrapper data-cm-metadata={dataCmMetadata}>
          <Link data-automation="isc-cta-secondary" href={ctaLink} onClick={onTargetClick} target={linkTargetType}>
            <ButtonOutline disabled={disabled}>{text}</ButtonOutline>
          </Link>
          {subTitlePlain && <CtaCaption>{subTitlePlain}</CtaCaption>}
        </Wrapper>
      ),
      'isc-cta-large-text': (
        <Wrapper data-cm-metadata={dataCmMetadata}>
          <LabelLink data-automation="isc-cta-large-text" disabled={disabled} onClick={onTargetClick} href={ctaLink} target={linkTargetType}>
            {text}
          </LabelLink>
        </Wrapper>
      ),
      'isc-cta-small-text': (
        <Wrapper data-cm-metadata={dataCmMetadata}>
          <LabelLink data-automation="isc-cta-small-text" small disabled={disabled} onClick={onTargetClick} href={ctaLink} target={linkTargetType}>
            {text}
          </LabelLink>
        </Wrapper>
      )
    }

    return ctaVariants[layoutVariant]
  }
}

CallToAction.defaultProps = {
  brand: 'nap',
  disabled: false,
  item: {},
  inverted: false
}

CallToAction.propTypes = {
  onTargetClick: func,
  brand: string,
  disabled: bool,
  item: shape({
    href: string.isRequired,
    layoutVariant: string,
    subTitlePlain: string,
    target: shape({
      type: string
    }),
    teaserTitle: string
  }),
  inverted: bool
}

const CtaCaption = createComponent(
  'CtaCaption',
  ({ theme }) => ({
    maxWidth: CTA_MAX_WIDTH,
    marginTop: `${theme.spacingMultiplier}px`,
    textAlign: 'left'
  }),
  Caption
)

const Wrapper = createComponent(
  'Wrapper',
  () => ({
    direction: 'ltr'
  }),
  'div'
)

export default CallToAction
